/* eslint-disable import/prefer-default-export */
export const isSettingEnabled = (
  setting,
  settings,
) => (setting && settings ? settings[setting] : true);
